// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.AdProductType

export enum ClientAdProductType {
  BASE_PACKAGE = 'BASE_PACKAGE',
  CONCIERGE_PAY_PER_LEASE = 'CONCIERGE_PAY_PER_LEASE',
  ENHANCED_PACKAGE = 'ENHANCED_PACKAGE',
  FLAT_FEE = 'FLAT_FEE',
  FLAT_FEE_FEED_CONNECT = 'FLAT_FEE_FEED_CONNECT',
  INTEGRATED_PAY_PER_LEASE = 'INTEGRATED_PAY_PER_LEASE',
  LEASE_UP = 'LEASE_UP',
  LISTING_SPOTLIGHT = 'LISTING_SPOTLIGHT',
  PAY_PER_CLICK = 'PAY_PER_CLICK',
  PAY_PER_LEAD = 'PAY_PER_LEAD',
  PAY_PER_LEASE = 'PAY_PER_LEASE',
  PREMIUM_PACKAGE = 'PREMIUM_PACKAGE',
  PREMIUM_PLUS_PACKAGE = 'PREMIUM_PLUS_PACKAGE',
  SIGNATURE_PACKAGE = 'SIGNATURE_PACKAGE',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
  SINGLE_FAMILY_DAILY_LISTINGS = 'SINGLE_FAMILY_DAILY_LISTINGS',
  SINGLE_FAMILY_FLAT_FEE = 'SINGLE_FAMILY_FLAT_FEE',
}

export const ClientAdProductType_values = [
  ClientAdProductType.BASE_PACKAGE,
  ClientAdProductType.CONCIERGE_PAY_PER_LEASE,
  ClientAdProductType.ENHANCED_PACKAGE,
  ClientAdProductType.FLAT_FEE,
  ClientAdProductType.FLAT_FEE_FEED_CONNECT,
  ClientAdProductType.INTEGRATED_PAY_PER_LEASE,
  ClientAdProductType.LEASE_UP,
  ClientAdProductType.LISTING_SPOTLIGHT,
  ClientAdProductType.PAY_PER_CLICK,
  ClientAdProductType.PAY_PER_LEAD,
  ClientAdProductType.PAY_PER_LEASE,
  ClientAdProductType.PREMIUM_PACKAGE,
  ClientAdProductType.PREMIUM_PLUS_PACKAGE,
  ClientAdProductType.SIGNATURE_PACKAGE,
  ClientAdProductType.SINGLE_FAMILY,
  ClientAdProductType.SINGLE_FAMILY_DAILY_LISTINGS,
  ClientAdProductType.SINGLE_FAMILY_FLAT_FEE,
] as const;
